import React, { FC, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/MainComponent/FormDetails/BasicForms.scss";
import {
  SetActionsBasicFormsDetails,
  SetActiveTabs, ////---tab---active
  SetActionsBasicFormscreateDetails,
  SetActionsBasicFormsEditDetails,
  setPreviousDataFetchActions,
  setIDverifycationanotherapidatasActions, ///aadhar---front verified
  settheAadarFrontImageAsBase64, ////As Front Base 64 ,
  settheAadarFrontFiles, ///As front files ,
  setTheOnboardPhoneNumber, ///for get the phone number
  setTheOtherAAdhaarOtpPhoneNuberAction,
  setTheaadharsentOtpReportActions, ///submit the---aadhar--otps
  setAadhar_counts,
  setTheAadhar_front_count,
  setTheAadharFristNumbers,
  setTheSumbitOtpFormsAadhar_verified,
  SetCasualActiveTabs,
  setCasualFormUpdateActions,
} from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import { Grid, Typography } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Button from "@mui/material/Button";
import { colors } from "@mui/material";
import { data } from "jquery";
// import ImageUploader from "./ImagerUpload";
import Select from "react-select";
import { store } from "../../../Redux/Store";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";
import { Downloads_doc } from "../FormDetails/Downloads_doc";
import { id } from "date-fns/locale";

const CasualBasicInfoTab = (props) => {
  const { propsID } = props;
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const fileInputRef = useRef(null);

  const Swal = require("sweetalert2");
  const form_data = new FormData();
  const user_image = new FormData();
  const Navigate = useNavigate();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialState = {
    first_name: "",
    dob: "",
    martial_status: "",
    gender: "",
    phone_number: "",
    qualification: "",
    scrum_id: "",
    user_uid: "",
    date_of_joining: "",
    blood_group: "",
    height: "",
    weight: "",
    aadhar_number: "",
    father_husband_name: "",
    emergency_contact_person: "",
    emergency_contact_number: "",
    aadhar_upload: "",
    profile_upload: "",
  };
  const [datas, setData] = useState(initialState);

  const [firsterro, setfirsterro] = useState("");
  const [lasterro, setlasterro] = useState("");
  const [emailerro, setEmailerro] = useState("");
  const [phoneerro, sphoneerro] = useState("");
  const [dateerro, setdateerro] = useState("");
  const [gendererror, setgendererror] = useState("");
  const [placeofBirtherr, setPlaceoferr] = useState("");
  const [sendIm, setImagest] = useState(false);
  const [profileErr, setProfleErr] = useState("");
  const [addharsent, setAadharsent] = useState(false);
  const [ActiveBtn, setActiveBtn] = useState(true);
  const [AregularBtn, setregularBtn] = useState(false);
  const [adharerr, setAdharErr] = useState("");
  const [EmergencyContact, setemergencyErr] = useState("");
  const [blopderr, setblodderr] = useState("");
  const [religionerr, setregliionerr] = useState("");

  const [heightErr, setheighterr] = useState("");
  const [weighterr, setweighterr] = useState("");
  const [employee_code_err, setemployee_code_err] = useState("");

  const [BloddGroupvalue, setbloodgroupval] = useState({
    value: "",
    label: "select",
  });
  const [religionval, setreligionval] = useState({
    value: "",
    label: "select",
  });
  const [profileFiles, setprofileIFile] = useState();
  const [aadhaarFiles, setaadhaarFile] = useState();
  const fileInputAadhaar = useRef(null);
  const [EmailID, setEmailID] = useState("");
  const UserData = useSelector((state) => state.users.UserData.data);
  const [PresentUrls, setPresentUrls] = useState([]);
  const [PresentUrlsProfile, setpresenturlProfile] = useState({
    ProfileUrls: "",
  });
  const [PresentUrlsAadhar, setpresenturlAadhar] = useState({
    aadhaarUrl: "",
  });

  const [forindex, setforindex] = useState();

  const Family_member_options = [
    { value: "0", label: "Father" },
    { value: "1", label: "Mother" },
    { value: "2", label: "Uncle" },
    { value: "3", label: "Aunt" },
    { value: "4", label: "Guardian" },
    { value: "5", label: "Brother" },
    { value: "6", label: "Sister" },
    { value: "7", label: "Grandfather" },
    { value: "8", label: "Grandmother" },
    { value: "9", label: "Husband" },
    { value: "10", label: "Wife" },
    { value: "11", label: "Son" },
    { value: "12", label: "Daughter" },
    { value: "13", label: "Cousin" },
    { value: "14", label: "Other" },
  ];

  const [family_member_val, setfamily_member_val] = useState(null);
  const [famli_err, set_famli_err] = useState("");
  const [manual_reasonerr, setmanual_reason_err] = useState("");

  useEffect(() => {
    if (UserData != undefined) {
      if (
        UserData.admin_access != undefined &&
        UserData.admin_access != "" &&
        UserData.admin_access != null &&
        UserData.admin_access != undefined
      ) {
        setEmailID(UserData.email);
      }
    }
  }, [state.users.UserData.data]);

  const style = {
    btn: {
      background: ActiveBtn == true ? "#234492" : "white",
      color: ActiveBtn == true ? "white" : "#000",
      border: ActiveBtn == true ? " 2px solid #fff" : "2px solid #234492",
    },
    regularbtn: {
      background: ActiveBtn == false ? "#234492" : "white",
      color: ActiveBtn == false ? "white" : "#000",
      border: ActiveBtn == false ? "2px solid #fff" : " 2px solid #234492",
    },
    // regularbtn: {
    //   background: AregularBtn ? "#234492" : "white",
    //   color: AregularBtn ? "white" : "#000",
    //   border: AregularBtn ? "2px solid #fff" : " 2px solid #234492",
    // },
  };
  const [sendotp, setsendotp] = useState(false);

  const aadhaarformData = new FormData();
  const [count, setCount] = useState(0); // Initialize count with one_mark
  const [aadharFrontCount, setAAdharfrontCout] = useState(0);
  const [Email, setEmail] = useState("");
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const GenderList = {
    Male: false,
    Female: false,
    other: false,
  };
  const [ForGender, SetGender] = useState(GenderList);
  const [image, setImage] = useState();
  ///---Age---------
  const [birthDate, setBirthDate] = useState("");
  const [age, setAge] = useState("");

  const initialStateCrop = {
    unit: "%", // Can be 'px' or '%'
    x: 0,
    y: 0,
    width: 100,
    height: 100,
  };
  const [crop, setCrop] = useState();

  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);

  const SubmitedForm = new FormData();
  const [url, setUrl] = useState();
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [imgfile2, setimgfile2] = useState();
  const [urlsign, setUrlsign] = useState();

  const muiltiplefiles = {
    file1: "",
    file2: "",
    file3: "",
  };

  const [numberoffiles, setfiles] = useState(muiltiplefiles);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [file, setFile] = useState([]);
  const [LastN, setLastN] = useState({ name: "", lastname: "" });

  const Blood_Group = [
    { value: "A +ve", label: "A +ve" },
    { value: "A -ve", label: "A -ve" },
    { value: "B +ve", label: "B +ve" },
    { value: "B -ve", label: "B -ve" },
    { value: "AB +ve", label: "AB +ve" },
    { value: "AB -ve", label: "AB -ve" },
    { value: "O +ve", label: "O +ve" },
    { value: "O -ve", label: "O -ve" },
    { value: "Rh +ve", label: "Rh +ve" },
    { value: "Rh -ve", label: "Rh -ve" },
    { value: "A1 +ve", label: "A1 +ve" },
    { value: "A1 -ve", label: "A1 -ve" },
    { value: "B1 +ve", label: "B1 +ve" },
    { value: "B1 -ve", label: "B1 -ve" },
    { value: "A1B +ve", label: "A1B +ve" },
    { value: "A1B -ve", label: "A1B -ve" },
  ];
  const religion = [
    { value: "HINDU", label: "HINDU" },
    { value: "MUSLIM", label: "MUSLIM" },
    { value: "CHRISTIAN", label: "CHRISTIAN" },
    { value: "JAIN", label: "JAIN" },
    { value: "BUDDHIST", label: "BUDDHIST" },
    { value: "OTHER", label: "OTHER" },
  ];

  const [OTPS, setOTPS] = useState("");
  const maritalStatusOptions = [
    { value: "unmarried", label: "Unmarried" },
    { value: "married", label: "Married" },
    { value: "others", label: "Others" },

  ];
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Others", label: "Others" },
  ];
  const [maritalStatusValue, setMaritalStatusValue] = useState({
    value: "",
    label: "Select",
  });
  const [genderDropdownValue, setGenderDropdownValue] = useState({
    value: "",
    label: "Select",
  });

  const [aahdaFrontCount, setAadharfrontCard] = useState(0); // Initialize count with one_mark

  const [Validations, setValidations] = useState(0);
  var FirstName;
  var LastName;

  const preventTyping = (e) => {
    e.preventDefault();
  };

  const inputRef = useRef(null);
  // const preventZoom = (event) => {

  //   if (event.ctrlKey || event.metaKey) {
  //     event.preventDefault();
  //   }

  //   if (event?.type  =="wheel") {
  //     event.preventDefault();
  //   }

  //    if (["e", "E", "+", "-", "."].includes(event.key)) {
  //     event.preventDefault();
  // }
  // if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //   event.preventDefault();
  // }
  // };

  const preventZoom = (event) => {
    // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "+" || event.key === "-" || event.type === "wheel")
    ) {
      event.preventDefault();
    }

    // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
    if (
      ["e", "E", "+", "-", "."].includes(event.key) ||
      event.key === "ArrowUp" ||
      event.key === "ArrowDown"
    ) {
      event.preventDefault();
    }
  };
  // Validate the pasted content and strip invalid characters
  const handlePaste = (event) => {
    let paste = (event.clipboardData || window.clipboardData).getData("text");

    // Strip non-numeric characters (except for digits)
    const filtered = paste.replace(/[^0-9]/g, "");

    // Prevent the default paste action and set the input value to the filtered result
    event.preventDefault();

    event.target.value = filtered;
    HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
  };

  const preventwheel = (event) => {
    if (
      (event.target && event.target.className == "form-control") ||
      event.target.class == "form-control"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      window.addEventListener("wheel", preventwheel, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventwheel);
    };
  }, []);

  useEffect(() => {
    const inputElement = inputRef.current;

    const preventScroll = (event) => {
      if (
        (event.target && event.target.className == "form-control") ||
        event.target.class == "form-control"
      ) {
        event.preventDefault();
      }
    };
    if (inputElement) {
      // Attach the listener to the window or a specific container
      window.addEventListener("wheel", preventScroll, { passive: false });
    }
    return () => {
      window.removeEventListener("wheel", preventScroll);
    };
  }, []);

  const incrementCount = () => {
    setCount(count + 1);
    // dispatch(setAadhar_counts(count + 1));
  };

  const AadharFront_cunts = () => {
    setAAdharfrontCout(aadharFrontCount + 1);

    // dispatch(
    //   setTheAadhar_front_count(
    //     aadharFrontCount + 1
    //   )
    // );
  };
  const Panverifed = () => {
    setAadharfrontCard(aahdaFrontCount + 1);
    setData({
      ...datas,
      aadhar_front_count: aahdaFrontCount,
    });
  };

  // const customStyles = {
  //   // menu: (provided, state) => ({
  //   //   ...provided,
  //   //   height: '200px',
  //   //   overflowY: 'auto',
  //   // }),

  // };

  const handleOTPChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value.slice(0, 1);
    if (index < otp.length - 1 && e.target.value !== "") {
      const nextInput = e.target.nextSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }

    setOtp(newOtp);
    // setOTPS(newOtp)
    var otpVal;
    let newOtpVal = newOtp.filter((char) => char !== "").join("");
    setOTPS(newOtpVal);
    // console.log(otpVal, "otpVal" , newOtp , OTPS);
  };
  useEffect(() => {
    if (state.CasualApproveRequestDatas.Inquriy) {
      const responseData = state.CasualApproveRequestDatas.Inquriy;
      setData({
        first_name: responseData.first_name || "",
        last_name: responseData.last_name || "",
        dob: responseData.dob || "",
        marital_status: responseData.martial_status || "",
        gender: responseData.gender || "",
        phone_number: responseData.phone_number || "",
        qualification: responseData.qualification || "",
        scrum_id: responseData.scrum_id || "",
        user_uid: responseData.user_uid || "",
        date_of_joining: responseData.date_of_joining || "",
        blood_group: responseData.blood_group || "",
        height: responseData.height || "",
        weight: responseData.weight || "",
        aadhar_number: responseData.aadhar_number || "",
        father_husband_name: responseData.father_husband_name || "",
        emergency_contact_person: responseData.emergency_contact_person || "",
        emergency_contact_number: responseData.emergency_contact_number || "",
        aadhar_upload: responseData.aadhar_upload || "",
        profile_upload: responseData.profile_upload || "",
        aadhar_upload: responseData?.aadhar_upload,
        profile_upload: responseData?.profile_upload,
      });
      setUrl(responseData.profile_upload);
      setUrlsign(responseData.aadhar_upload);
      setpresenturlProfile({
        ProfileUrls: responseData.profile_upload || "",
      });
      setpresenturlAadhar({
        aadhaarUrl: responseData.aadhar_upload || "",
      });
    }
  }, [state.CasualApproveRequestDatas.Inquriy]);

  // ////---Aadhar---Retieve---datas,,,
  useEffect(() => {
    if (
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != undefined &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != null &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas != "" &&
      state.idverfiyicationapidatas.AAdharFrontImagesDatas.name != undefined
    ) {
      const dobData = state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob;
      let formattedDOB = "";
      if (dobData) {
        const cleanDob = dobData.toString().trim();
        if (cleanDob.includes("/")) {
          const parts = cleanDob.split("/");
          if (parts.length === 3) {
            const [day, month, year] = parts;
            formattedDOB = `${year.toString().trim()}-${month.toString().trim().padStart(2, "0")}-${day.toString().trim().padStart(2, "0")}`;
          }
        } else if (cleanDob.includes("-")) {
          const parts = cleanDob.split("-");
          if (parts.length === 3) {
            if (parts[0].toString().trim().length === 4) {
              formattedDOB = cleanDob;
            } else {
              const [day, month, year] = parts;
              formattedDOB = `${year.toString().trim()}-${month.toString().trim().padStart(2, "0")}-${day.toString().trim().padStart(2, "0")}`;
            }
          }
        } else if (cleanDob.length === 4 && !isNaN(cleanDob)) {
          formattedDOB = `${cleanDob}-01-01`;
        } else {
          formattedDOB = cleanDob;
        }
      }

      const extractedAadhar =
        state.idverfiyicationapidatas.FirstAadharNumber != ""
          ? state.idverfiyicationapidatas.FirstAadharNumber
          : state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id
            ? state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
              /\s/g,
              "",
            )
            : "";

      setData((prevDatas) => ({
        ...prevDatas,
        first_name: state.idverfiyicationapidatas.AAdharFrontImagesDatas.name
          ? state.idverfiyicationapidatas.AAdharFrontImagesDatas.name.toUpperCase()
          : "",
        dob: formattedDOB,
        gender:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas.gender || "",
        aadhar_number: extractedAadhar,
        father_husband_name:
          state.idverfiyicationapidatas.AAdharFrontImagesDatas
            ?.father_spouse_name,
      }));
    }
  }, [
    state.idverfiyicationapidatas.AAdharFrontImagesDatas,
    state.idverfiyicationapidatas.FirstAadharNumber,
  ]);

  useEffect(() => {
    if (datas.gender) {
      setGenderDropdownValue({
        value: datas.gender,
        label: datas.gender,
      });
    } else {
      setGenderDropdownValue({ value: "", label: "Select" });
    }
  }, [datas.gender]);

  useEffect(() => {
    if (datas.marital_status) {
      setMaritalStatusValue({
        value: datas.marital_status,
        label: datas.marital_status,
      });
    } else {
      setMaritalStatusValue({ value: "", label: "Select" });
    }
  }, [datas.marital_status]);
  useEffect(() => {
    if (datas.blood_group) {
      setbloodgroupval({
        value: datas.blood_group,
        label: datas.blood_group,
      });
    } else {
      setbloodgroupval({ value: "", label: "Select" });
    }
  }, [datas.blood_group]);

  useEffect(() => {
    calculateAge();
  }, [datas.dob]);

  function calculateAge() {
    setAge("");
    if (!datas.dob.includes("undefined")) {
      console.log(datas.dob, "data.datas.dob.");
      const today = new Date();
      const birthDate = new Date(datas.dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      setAge(age);
    }
  }

  useEffect(() => {
    const isAgeVerificationRequired = age !== "" && age <= 17;

    if (isAgeVerificationRequired) {
      document.activeElement?.blur();
      Swal.fire({
        title: "Age Verification Required",
        text: "You must be 18 or older to proceed with this Onboarding process.",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "rgb(255 0 0)",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        confirmButtonText: "Proceed",
      }).then((result) => {
        if (result.isConfirmed) {
          if (state.SideBarFiles.SideBarFile === "My Onboarding List") {
            navigate("/myonboarding");
          } else if (state.SideBarFiles.SideBarFile === "Approve Request") {
            navigate("/approverequestemp");
          } else if (state.SideBarFiles.SideBarFile === "Client") {
            navigate("/clientDetails");
          } else if (state.SideBarFiles.SideBarFile === "Onboarding") {
            navigate("/fieldagent");
          }
        }
      });
    } else {
      // ✅ handle age > 58 logic
      if (age !== "" && age > 58) {
        document.activeElement?.blur();
        Swal.fire({
          title: "Date of Birth Mismatch",
          text: "The entered date of birth indicates age over 58, which is not allowed for this onboarding.",
          icon: "error",
          confirmButtonColor: "rgb(255 0 0)",
          allowOutsideClick: false,
          confirmButtonText: "Proceed",
          showCancelButton: false,
        }).then((result) => {
          if (result.isConfirmed) {
            if (state.SideBarFiles.SideBarFile === "My Onboarding List") {
              navigate("/myonboarding");
            } else if (state.SideBarFiles.SideBarFile === "Approve Request") {
              navigate("/approverequestemp");
            } else if (state.SideBarFiles.SideBarFile === "Client") {
              navigate("/clientDetails");
            } else if (state.SideBarFiles.SideBarFile === "Onboarding") {
              navigate("/fieldagent");
            }
          }
        });
      }
    }
  }, [age, state.SideBarFiles.SideBarFile, datas.dob, datas]);

  // ///--------------------Previous----API----
  // useEffect(()=>{
  //    const payload ={
  //     type:"BIF"
  //    }
  //   dispatch(setPreviousDataFetchActions(payload))
  // },[])

  const fixedCropSize = { width: 300, height: 200 };
  //  console.log(crop , "8707jyuiycrop");
  const cancel = (e) => {
    setalert(true);

    // setImageField("");
    setUrl("");
    setpresenturlProfile({ ProfileUrls: "" });
  };

  const HandleChanges = (e) => {
    console.log(e.target.name, "e.target.name", e.target.value);

    if (e.target.name == "phoneNum") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.slice(0, 10),
      });
    } else if (e.target.name == "gender") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value,
      });
    }

    if (e.target.name == "email_id") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value,
      });
    }

    if (e.target.name == "personal_identification_mark") {
      const { name, value } = e.target;
      setData({
        ...datas,
        [name]: value,
      });
    }
    if (e.target.name == "aadhar_number") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.slice(0, 12),
      });
    } else if (
      e.target.name != "gender" &&
      e.target.name != "phoneNum" &&
      e.target.name != "aadhar_number"
    ) {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value.toUpperCase(),
      });
    } else if (e.target.name == "height" || e.target.name == "weight") {
      const { name, value } = e.target;

      setData({
        ...datas,
        [name]: value,
      });
    }
  };

  // ----------------------Profiles-----------------------------
  const getCroppedImg = (imageRef, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        // const croppedFile = new File([blob], fileName, {
        //   type: "image/jpeg",
        // });
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        console.log(croppedFile, "qw89croppedFile");
        var file = croppedFile;
        if (CroppImageViewCount == 1) {
          setFile(croppedFile);
          var reader = new FileReader();
          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);
          if (croppedFile) {
            // setTimeout(() => {
            setCroppImageView(false);

            // }, 0);
            const generateRandomNumber = (digits = 12) => {
              const min = 10 ** (digits - 1);
              const max = 10 ** digits;
              return Math.floor(min + Math.random() * (max - min));
            };

            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/${CroppImageViewCount == 1 ? "user_image" : "aadharfront"}/${CroppImageViewCount == 1 ? `user_image${randomNumber}` : `aadharfront${randomNumber}`}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };

            const Presentdata = createPresentData(croppedFile);
            console.log(Presentdata, "sdsasd Presentdata");

            axios({
              url: PresentUrl,
              method: "post",
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                console.log("Files uploaded successfully:", response.data);
                const uploadedFiles = response.data.data; // Adjust based on actual response structure
                console.log(uploadedFiles, "uploadedFiles");

                const newUrls = uploadedFiles.map((file) => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile,
                }));

                setPresentUrls((prevUrls) => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                });
                setpresenturlProfile({
                  ProfileUrls: String(response.data.data).split("?")[0],
                });
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });
          }
        } else if (CroppImageViewCount == 2) {
          setfiles({
            ...numberoffiles,
            file2: croppedFile,
          });
          setimgfile2(croppedFile);
          // console.log(croppedFile, "croppedFile");
          if (croppedFile) {
            setTimeout(() => {
              setCroppImageView(false);
            }, 0);
          }

          var file = croppedFile;
          var reader = new FileReader();
          ////another ---api
          // setaadharFrontfile(croppedFile);

          ///setIDverifycationanotherapidatasActions -------
          reader.onloadend = function () {
            dispatch(settheAadarFrontImageAsBase64(reader.result)); /// As Base64
            setUrlsign(reader.result);
          };
          reader.readAsDataURL(file);
          setCroppImageView(false);

          if (croppedFile) {
            aadhaarformData.append("aadhar_card", croppedFile);
            const generateRandomNumber = (digits = 12) => {
              const min = 10 ** (digits - 1);
              const max = 10 ** digits;
              return Math.floor(min + Math.random() * (max - min));
            };

            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/${CroppImageViewCount == 1 ? "user_image" : "aadharfront"}/${CroppImageViewCount == 1 ? `user_image${randomNumber}` : `aadharfront${randomNumber}`}.${croppedFile.type.split("/")[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };

            const Presentdata = createPresentData(croppedFile);
            axios({
              url: PresentUrl,
              method: "post",
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                console.log("Files uploaded successfully:", response.data);
                const uploadedFiles = response.data.data; // Adjust based on actual response structure
                console.log(uploadedFiles, "uploadedFiles");

                const newUrls = uploadedFiles.map((file) => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile,
                }));

                // Update PresentUrls state
                setPresentUrls((prevUrls) => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                });

                setpresenturlAadhar({
                  aadhaarUrl: String(response.data.data).split("?")[0],
                });
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });

            const payload = {
              fromdata: aadhaarformData,
              Imagetype: 1,
            };
            dispatch(setIDverifycationanotherapidatasActions(payload));
            incrementCount();
            dispatch(
              setTheAadhar_front_count(
                state.OnboardngCounts.aadhar_front_count + 1,
              ),
            );
            blob.name = fileName;
          }
        }
        resolve(croppedFile);
      }, "image/jpeg");
    });
  };

  const updateAvatar = (imgSrc) => {
    if (CroppImageViewCount == 1) {
      // fileInputRef.current = imgSrc;
      fileInputRef.current.value = imgSrc;
    } else if (CroppImageViewCount == 2) {
      fileInputAadhaar.current.value = imgSrc;
    }
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      console.log(imgsrc, "imgsrc");
    }
    // const file = e.target.files[0];

    // setCroppImageView(false)

    // if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    //    console.log(file ,"0827301983902");

    //   toast.error(` File size should be less than ${MAX_FILE_SIZE_MB}  MB`, {
    //     position: toast.POSITION.TOP_RIGHT,
    //   });

    //   return;
    // }
    // const reader = new FileReader();
    // reader.onload = () => {
    //   imgRef.current.src = reader.result;
    // };
    // reader.readAsDataURL(file);
  };

  const setCompletedCrop = async (c) => {
    // console.log(c, "newfile.jpeg", imgRef.current);
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };
  const handleFiles = (e) => {
    setImagest(true);
    setShowCropper(true);
    setProfleErr("");
    // selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setprofileIFile(e);
    setalert(true);
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;
    setforindex(1);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e);
          });
        });
        reader.readAsDataURL(file);
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }
  };

  const handleFiles2 = (e) => {
    setAadharsent(true);

    setCroppImageViewCount(2);
    setCroppImageView(true);
    setAdharErr("");
    setalert(true);
    setaadhaarFile(e);
    // selectedImage(e);
    const file = e.target.files[0];
    console.log(file, "file");
    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    setforindex(0);

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }
            selectedImage(e);
          });
        });
        reader.readAsDataURL(file);
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }
  };

  const cancel2 = (e) => {
    setalert(true);
    setUrlsign("");
    setpresenturlAadhar({ aadhaarUrl: "" });

    setfiles({
      ...numberoffiles,
      file2: "",
    });
  };

  /////--------------------------NEXT____FUNCTION--------------------------
  // const HandleNext = (e) => {
  //   var a = 0;

  //   if (
  //     state.FormsIDList.BasicFormID != "" &&
  //     state.FormsSDETAILS.BasciForm != undefined
  //   ) {
  //     var personalIdentificationMark =
  //       state.FormsSDETAILS.BasciForm.personal_identification_mark;
  //     var isPersonalIdentificationMarkEqual = personalIdentificationMark
  //       ? personalIdentificationMark.length > 0
  //         ? datas.personal_identification_mark === personalIdentificationMark[0]
  //         : datas.personal_identification_mark === ""
  //       : datas.personal_identification_mark === "";

  //     // Normalize and compare user image URL
  //     var normalizedUrl = url?.trim().toLowerCase();
  //     var userImageMediaUrl =
  //       state.FormsSDETAILS.BasciForm.user_image?.media_url || "";
  //     var normalizedUserImageMediaUrl = userImageMediaUrl?.trim().toLowerCase();
  //     var isUserImageUrlEqual = normalizedUrl === normalizedUserImageMediaUrl;

  //     // Normalize and compare Aadhar front media URL
  //     var normalizedUrlSign = urlsign?.trim().toLowerCase();
  //     var userAadhaaMediaUrl =
  //       state.FormsSDETAILS.BasciForm.aadhar_front?.media_url ||
  //       "<default_url_or_empty>";
  //     var normalizedUserAadhaaMediaUrl = userAadhaaMediaUrl
  //       ?.trim()
  //       .toLowerCase();
  //     var isUserAadharUrlEqual =
  //       normalizedUrlSign === normalizedUserAadhaaMediaUrl;
  //   }

  //   const fetchUploadFiles = async () => {
  //     await Promise.all(
  //       PresentUrls.map(async (item) => {
  //         try {
  //           if (item != undefined && item != null) {
  //             const response = await fetch(item.url, {
  //               method: "PUT",
  //               headers: {
  //                 "Content-Type": item.type,
  //                 "x-amz-acl": "public-read",
  //               },
  //               body: item.putfiles,
  //             });

  //             if (!response.ok) {
  //               throw new Error(`HTTP error! Status: ${response.status}`);
  //             }

  //             console.log(
  //               PresentUrlsAadhar,
  //               "PresentUrlsAadhar",
  //               PresentUrlsProfile,
  //             );

  //             setUrlsign(PresentUrlsAadhar.aadhaarUrl);
  //             setUrl(PresentUrlsProfile.ProfileUrls);
  //           }
  //         } catch (error) {
  //           console.error("Error uploading files:", error);
  //         }
  //       }),
  //     );
  //   };

  //   if (
  //     state.FormsIDList.BasicFormID == "" &&
  //     state.FormsSDETAILS.BasciForm == ""
  //   ) {
  //     let CreateDatas = {
  //       first_name: datas.first_name.trim().toUpperCase(),
  //       last_name: "",
  //       gender: datas.gender,
  //       date_of_birth: datas.dob,
  //       place_of_birth: datas.placeofBirth,
  //       email_id: Email,
  //       phone_number: datas.phoneNum,
  //       client_id: state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
  //       role_id: state.NumberCounts.EmployeeRoleId, ///role----id
  //       aadhar_number: datas.aadhar_number,
  //       aadhar_count: state.OnboardngCounts.aadhar_count,
  //       aadhar_front_count: state.OnboardngCounts.aadhar_front_count,
  //       aadhar_transaction_id: "",
  //       personal_identification_mark: [datas.personal_identification_mark],
  //       religion: datas.religion,
  //       emergency_contact_number: datas.emergency_contact_number,
  //       blood_group: datas.blood_group,
  //       user_image: PresentUrlsProfile.ProfileUrls,
  //       aadhar_front: PresentUrlsAadhar.aadhaarUrl,
  //       weight: datas.weight,
  //       height: datas.height,
  //       emergency_contact_relation: datas?.emergency_contact_relation,
  //       marital_status: datas.marital_status,
  //       qualification: datas.qualification,
  //       date_of_joining: datas.date_of_joining,
  //       father_husband_name: datas.father_husband_name,
  //       emergency_contact_person: datas.emergency_contact_person,
  //       // manual_aadhaar_reason:datas?.manual_aadhaar_reason
  //       aadhar_verified: false,
  //       user_uid: datas?.user_uid,
  //     };
  //     if (url == undefined || url == null || url == "") {
  //       setProfleErr("*Profile image is required");
  //       a = 1;
  //     }

  //     // if (addharsent) {
  //     if (urlsign == undefined || urlsign == null || urlsign == "") {
  //       setAdharErr("*Aadhaar image is required");
  //       a = 1;
  //     }

  //     //       if(ActiveBtn == false){
  //     //  if( datas.manual_aadhaar_reason == null ||datas.manual_aadhaar_reason == ""|| datas.manual_aadhaar_reason == null || datas.manual_aadhaar_reason == undefined){
  //     // setmanual_reason_err("*Remarks are required for manual verification");
  //     //   a = 1;
  //     //  }
  //     // }

  //     if (
  //       datas.emergency_contact_relation == null ||
  //       datas.emergency_contact_relation == "" ||
  //       datas.emergency_contact_relation == null ||
  //       datas.emergency_contact_relation == undefined
  //     ) {
  //       set_famli_err("*Emergency contact relationship is required");
  //       a = 1;
  //     }

  //     // if(datas.religion == "" || datas.religion == undefined || datas.religion == null){
  //     //    a = 1;
  //     //    setregliionerr("*Religion is required")
  //     // }

  //     if (
  //       datas.emergency_contact_number != "" &&
  //       datas.emergency_contact_number != undefined &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number.length > 10
  //     ) {
  //       a = 1;
  //       sphoneerro("*Emergency contact should not greater than 10 digits");
  //     }

  //     if (datas.first_name == "") {
  //       a = 1;
  //       setfirsterro("*Name is required");
  //     }
  //     //       if (datas.height == "") {
  //     //   a = 1;
  //     //   setheighterr("*Height is required");
  //     // }
  //     //       if (datas.weight == "") {
  //     //   a = 1;
  //     //   setweighterr("*Weight is required");
  //     // }
  //     if (Email != "" && Email != null && !validator.isEmail(Email)) {
  //       setEmailerro("*Enter valid mail id");
  //       a = 1;
  //     }

  //     if (datas.dob == "" || datas.dob.includes("undefined")) {
  //       a = 1;
  //       setdateerro("*Date of birth is required");
  //     }

  //     if (datas.phoneNum == "") {
  //       a = 1;
  //       sphoneerro("*Phone Number  is required");
  //     }
  //     if (
  //       datas.emergency_contact_number == "" ||
  //       datas.emergency_contact_number == null
  //     ) {
  //       a = 1;
  //       setemergencyErr("*Emergency contact  is required");
  //     }

  //     if (datas.phoneNum != "" && datas.phoneNum.length < 10) {
  //       a = 1;
  //       sphoneerro("*Phone Number  should not less than 10 digits");
  //     }

  //     if (datas.phoneNum != "" && datas.phoneNum.length > 10) {
  //       a = 1;
  //       sphoneerro("*Phone Number should not  greater than 10 digits");
  //     }

  //     if (datas.gender == "" || datas.gender == undefined) {
  //       a = 1;
  //       setgendererror("*Gender is required");
  //     }

  //     if (
  //       datas.blood_group == "" ||
  //       datas.blood_group == null ||
  //       datas.blood_group == undefined
  //     ) {
  //       setblodderr("*Blood group is required");
  //       a = 1;
  //     }
  //     if (
  //       datas.emergency_contact_number != "" &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number != undefined &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number.length < 10
  //     ) {
  //       setemergencyErr("*Emergency contact should not less than 10 digits");
  //       a = 1;
  //     }

  //     if (
  //       datas.phoneNum &&
  //       datas.emergency_contact_number &&
  //       datas.phoneNum === datas.emergency_contact_number
  //     ) {
  //       a = 1;
  //       setemergencyErr(
  //         "*Emergency contact number cannot be the same as phone number",
  //       );
  //     }

  //     if (datas.user_uid && datas.user_uid != null && datas.user_uid != "") {
  //       if (datas.user_uid.trim().length < 3) {
  //         setemployee_code_err("*Employee Code must be at least 3 characters");
  //         a = 1;
  //       }
  //     }

  //     if (
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number != "" &&
  //       datas.emergency_contact_number.length > 10
  //     ) {
  //       a = 1;
  //       sphoneerro("*Emergency contact should not  greater than 10 digits");
  //     }

  //     if (
  //       a == 0 &&
  //       Validations == 0 &&
  //       (sendIm == true || addharsent == true)
  //     ) {
  //       fetchUploadFiles();
  //     }

  //     if (a == 0) {
  //       const payload = {
  //         form_data: CreateDatas,
  //         Retieveid: state.FormsIDList.BasicFormID,
  //         Move: 2,
  //       };
  //       dispatch(SetActionsBasicFormscreateDetails(payload));
  //       setPresentUrls([]);
  //       setUrl("");
  //       setUrlsign("");
  //       dispatch(setTheOnboardPhoneNumber(datas.phoneNum));
  //     }
  //   }

  //   if (
  //     state.FormsIDList.BasicFormID != "" &&
  //     state.FormsSDETAILS.BasciForm != ""
  //   ) {
  //     if (
  //       datas.email_id != "" &&
  //       datas.email_id != null &&
  //       !validator.isEmail(datas.email_id)
  //     ) {
  //       setEmailerro("*Enter valid mail id");
  //       a = 1;
  //     }

  //     if (datas.first_name == "") {
  //       a = 1;
  //       setfirsterro("*Name is required");
  //     }
  //     if (
  //       datas.emergency_contact_number == "" ||
  //       datas.emergency_contact_number == null ||
  //       datas.emergency_contact_number == undefined
  //     ) {
  //       setemergencyErr("*Emergency Contact is required");
  //       a = 1;
  //     }
  //     if (
  //       datas.emergency_contact_relation == null ||
  //       datas.emergency_contact_relation == "" ||
  //       datas.emergency_contact_relation == null ||
  //       datas.emergency_contact_relation == undefined
  //     ) {
  //       set_famli_err("*Emergency Contact relationship is required");
  //       a = 1;
  //     }
  //     //       if(ActiveBtn == false){
  //     //  if( datas.manual_aadhaar_reason == null ||datas.manual_aadhaar_reason == ""|| datas.manual_aadhaar_reason == null || datas.manual_aadhaar_reason == undefined){
  //     // setmanual_reason_err("*Remarks are required for manual verification");
  //     //   a = 1;
  //     //  }
  //     // }
  //     //            if (datas.height == "") {
  //     //   a = 1;
  //     //   setheighterr("*Height is required");
  //     // }
  //     //       if (datas.weight == "") {
  //     //   a = 1;
  //     //   setweighterr("*Weight is required");
  //     // }

  //     if (
  //       datas.emergency_contact_number != "" &&
  //       datas.emergency_contact_number != undefined &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number.length > 10
  //     ) {
  //       a = 1;
  //       sphoneerro("*Emergency contact should not greater than 10 digits");
  //     }

  //     if (
  //       datas.dob == "" ||
  //       datas.dob == undefined ||
  //       datas.dob.includes("undefined")
  //     ) {
  //       a = 1;
  //       setdateerro("*Date of birth is required");
  //     }

  //     if (
  //       datas.blood_group == "" ||
  //       datas.blood_group == null ||
  //       datas.blood_group == undefined
  //     ) {
  //       setblodderr("*Blood group is required");
  //       a = 1;
  //     }

  //     if (datas.user_uid && datas.user_uid != null && datas.user_uid != "") {
  //       if (datas.user_uid.trim().length < 3) {
  //         setemployee_code_err("*Employee Code must be at least 3 characters");
  //         a = 1;
  //       }
  //     }
  //     //    if(datas.religion == "" || datas.religion == null || datas.religion == undefined){
  //     //     a = 1;
  //     //     setregliionerr("*Religion is required")
  //     //  }

  //     if (
  //       datas.phoneNum == "" ||
  //       datas.phoneNum == undefined ||
  //       datas.phoneNum == null
  //     ) {
  //       a = 1;
  //       sphoneerro("*Phone Number is required");
  //     }
  //     if (
  //       datas.emergency_contact_number == "" ||
  //       datas.emergency_contact_number == null
  //     ) {
  //       a = 1;
  //       setemergencyErr("*Emergency contact  is required");
  //     }

  //     if (
  //       datas.phoneNum != "" &&
  //       datas.phoneNum != undefined &&
  //       datas.phoneNum != null &&
  //       datas.phoneNum.length < 10
  //     ) {
  //       a = 1;
  //       sphoneerro("*Phone Number should not less than 10 digits");
  //     }

  //     if (
  //       datas.emergency_contact_number != "" &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number != undefined &&
  //       datas.emergency_contact_number != null &&
  //       datas.emergency_contact_number.length < 10
  //     ) {
  //       setemergencyErr("*Emergency contact should not less than 10 digits");

  //       a = 1;
  //     }

  //     if (
  //       datas.phoneNum &&
  //       datas.emergency_contact_number &&
  //       datas.phoneNum === datas.emergency_contact_number
  //     ) {
  //       a = 1;
  //       setemergencyErr(
  //         "*Emergency contact number cannot be the same as phone number",
  //       );
  //     }

  //     if (
  //       datas.phoneNum != "" &&
  //       datas.phoneNum != undefined &&
  //       datas.phoneNum != null &&
  //       datas.phoneNum.length > 10
  //     ) {
  //       a = 1;
  //       sphoneerro("*Phone Number should not  greater than 10 digits");
  //     }

  //     if (datas.gender == "" || datas.gender == undefined) {
  //       a = 1;
  //       setgendererror("*Gender is required");
  //     }
  //     // if (datas.placeofBirth == "") {
  //     //   a = 1;
  //     //   setPlaceoferr("*place of birth is required");
  //     // }
  //     // if (!sendIm) {
  //     if (url == undefined || url == null || url == "") {
  //       setProfleErr("*Profile image is required");
  //       a = 1;
  //     }

  //     // if (addharsent) {
  //     if (urlsign == undefined || urlsign == null || urlsign == "") {
  //       setAdharErr("*Aadhaar image is required");
  //       a = 1;
  //     }
  //   }

  //   if (
  //     a == 0 &&
  //     state.FormsIDList.BasicFormID !== "" &&
  //     state.FormsIDList.BasicFormID === state.FormsSDETAILS.BasciForm.id &&
  //     (datas.first_name !== state.FormsSDETAILS.BasciForm.first_name ||
  //       datas.phoneNum !== state.FormsSDETAILS.BasciForm.phone_number ||
  //       datas.email_id !== state.FormsSDETAILS.BasciForm.email_id ||
  //       datas.placeofBirth !== state.FormsSDETAILS.BasciForm.place_of_birth ||
  //       datas.dob !== state.FormsSDETAILS.BasciForm.date_of_birth ||
  //       datas.aadhar_number !== state.FormsSDETAILS.BasciForm.aadhar_number ||
  //       datas.gender !== state.FormsSDETAILS.BasciForm.gender ||
  //       !isUserImageUrlEqual || // Compare user image URLs
  //       !isUserAadharUrlEqual || // Compare Aadhar URLs
  //       datas.blood_group !== state.FormsSDETAILS.BasciForm.blood_group ||
  //       datas.emergency_contact_number !==
  //         state.FormsSDETAILS.BasciForm.emergency_contact_number ||
  //       datas.marital_status !==
  //         state.FormsSDETAILS.BasciForm?.marital_status ||
  //       datas.qualification !== state.FormsSDETAILS.BasciForm?.qualification ||
  //       datas.date_of_joining !==
  //         state.FormsSDETAILS.BasciForm?.date_of_joining ||
  //       datas.father_husband_name !==
  //         state.FormsSDETAILS.BasciForm?.father_husband_name ||
  //       datas.emergency_contact_person !==
  //         state.FormsSDETAILS.BasciForm?.emergency_contact_person ||
  //       !isPersonalIdentificationMarkEqual ||
  //       datas.weight !== state.FormsSDETAILS.BasciForm?.weight ||
  //       datas.height !== state.FormsSDETAILS.BasciForm?.height ||
  //       datas?.emergency_contact_relation !==
  //         state.FormsSDETAILS.BasciForm?.emergency_contact_relation ||
  //       // datas.manual_aadhaar_reason !== state.FormsSDETAILS.BasciForm.manual_aadhaar_reason
  //       datas?.user_uid !== state.FormsSDETAILS.BasciForm?.user_uid)
  //   ) {
  //     if (
  //       a == 0 &&
  //       Validations == 0 &&
  //       (sendIm == true || addharsent == true)
  //     ) {
  //       fetchUploadFiles();
  //     }

  //     if (a == 0 && Validations == 0) {
  //       let NormalData = {
  //         first_name: datas.first_name.trim().toUpperCase(),
  //         last_name: "",

  //         gender: datas.gender,
  //         date_of_birth: datas.dob,
  //         place_of_birth: datas.placeofBirth,
  //         email_id:
  //           datas.email_id != null && datas.email_id != undefined
  //             ? datas.email_id.toLowerCase().trim()
  //             : null,
  //         phone_number: datas.phoneNum,
  //         client_id: state.NumberCounts.branchId, //branch---id ---get ---from----field agent clicked if
  //         role_id: state.NumberCounts.EmployeeRoleId, ///role----id
  //         aadhar_number: datas.aadhar_number,
  //         aadhar_count: state.OnboardngCounts.aadhar_count,
  //         aadhar_front_count: state.OnboardngCounts.aadhar_front_count,
  //         aadhar_transaction_id: "",
  //         personal_identification_mark: [datas.personal_identification_mark],
  //         religion: datas.religion,
  //         emergency_contact_number: datas.emergency_contact_number,
  //         blood_group: datas.blood_group,
  //         user_image: PresentUrlsProfile.ProfileUrls,
  //         aadhar_front: PresentUrlsAadhar.aadhaarUrl,
  //         weight: datas.weight,
  //         height: datas.height,
  //         emergency_contact_relation: datas?.emergency_contact_relation,
  //         marital_status: datas.marital_status,
  //         qualification: datas.qualification,
  //         date_of_joining: datas.date_of_joining,
  //         father_husband_name: datas.father_husband_name,
  //         emergency_contact_person: datas.emergency_contact_person,
  //         // manual_aadhaar_reason:datas?.manual_aadhaar_reason
  //         aadhar_verified: state.FormsSDETAILS.BasciForm?.aadhar_verified,
  //         user_uid: datas?.user_uid,
  //       };
  //       // );

  //       if (sendIm) {
  //         form_data.append("user_image", file);
  //       }

  //       if (addharsent) {
  //         form_data.append("aadhar_front", imgfile2);
  //       }
  //       const payload = {
  //         // form_data: form_data,
  //         form_data: NormalData,
  //         user_image: user_image,
  //         Retieveid: state.FormsIDList.BasicFormID,
  //       };
  //       dispatch(setTheOnboardPhoneNumber(datas.phoneNum));

  //       dispatch(SetActionsBasicFormsEditDetails(payload));
  //       setPresentUrls([]);
  //       setUrl("");
  //       setUrlsign("");
  //     }
  //   }
  //   //
  //   // else

  //   if (
  //     a == 0 &&
  //     state.FormsIDList.BasicFormID !== "" &&
  //     // state.FormsSDETAILS.BasciForm !== [] &&
  //     datas.first_name === state.FormsSDETAILS.BasciForm.first_name &&
  //     datas.phoneNum === state.FormsSDETAILS.BasciForm.phone_number &&
  //     datas.email_id === state.FormsSDETAILS.BasciForm.email_id &&
  //     datas.dob === state.FormsSDETAILS.BasciForm.date_of_birth &&
  //     datas.gender === state.FormsSDETAILS.BasciForm.gender &&
  //     datas.placeofBirth === state.FormsSDETAILS.BasciForm.place_of_birth &&
  //     datas.aadhar_number == state.FormsSDETAILS.BasciForm.aadhar_number &&
  //     isUserImageUrlEqual && // Use the comparison result for user image URL
  //     isUserAadharUrlEqual && // Use the comparison result for Aadhar URL
  //     datas.blood_group === state.FormsSDETAILS.BasciForm.blood_group &&
  //     datas.emergency_contact_number ===
  //       state.FormsSDETAILS.BasciForm.emergency_contact_number &&
  //     datas.emergency_contact_relation ===
  //       state.FormsSDETAILS.BasciForm.emergency_contact_relation &&
  //     // datas.manual_aadhaar_reason === state.FormsSDETAILS.BasciForm.manual_aadhaar_reason &&
  //     datas?.user_uid == state.FormsSDETAILS.BasciForm?.user_uid &&
  //     isPersonalIdentificationMarkEqual
  //   ) {
  //     // console.log("tab");
  //     dispatch(SetActiveTabs(2));
  //     //
  //   }
  // };

  console.log(
    state.idverfiyicationapidatas.AAdharFrontImagesDatas,
    "state.idverfiyicationapidatas.AAdharFrontImagesDatas",
    sendotp,
    state.NumberCounts.Editable,
    state.AadharOtherPartyAPIPhoneOtp.Client_id,
  );

  const fetchUploadFiles = async () => {
    await Promise.all(
      PresentUrls.map(async (item, index) => {
        try {
          if (item != undefined && item != null) {
            const response = await fetch(item.url, {
              method: "PUT",
              headers: {
                "Content-Type": item.type,
                "x-amz-acl": "public-read",
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            console.log(
              PresentUrlsAadhar,
              "PresentUrlsAadhar",
              PresentUrlsProfile,
            );

            if (index === 0) {
              setUrlsign(PresentUrlsAadhar.aadhaarUrl);
            } else if (index === 1) {
              setUrl(PresentUrlsProfile.ProfileUrls);
            }
          }
        } catch (error) {
          console.error("Error uploading files:", error);
        }
      }),
    );
  };

  const HandleSaveNext = async () => {
    if (PresentUrls && PresentUrls.length > 0) {
      await fetchUploadFiles();
    }
    const payload = {
      id: propsID,
      data: {
        first_name: datas.first_name,
        dob: datas.dob,
        martial_status: datas.marital_status,
        gender: datas.gender,
        phone_number: datas.phone_number,
        qualification: datas.qualification,
        scrum_id: datas.scrum_id,
        user_uid: datas.user_uid,
        date_of_joining: datas.date_of_joining,
        blood_group: datas.blood_group,
        height: datas.height,
        weight: datas.weight,
        // aadhar_number: datas.aadhar_number,
        father_husband_name: datas.father_husband_name,
        emergency_contact_person: datas.emergency_contact_person,
        emergency_contact_number: datas.emergency_contact_number,
        aadhar_upload: PresentUrlsAadhar.aadhaarUrl || urlsign,
        profile_upload: PresentUrlsProfile.ProfileUrls || url,
      },

      Functions: () => {
        dispatch(SetCasualActiveTabs(2));
      },
    };
    dispatch(setCasualFormUpdateActions(payload));
    setPresentUrls([]);
    console.log(payload, "jkadjkasjkdasjkdkas");
  };

  return (
    <>
      <div className="">
        <div
        //className={stateDisplay ? " POPUP" : "outerPOPUP"}
        >
          <div className=" BodyContent">
            <div className="card">
              <div className="card-body cards ">
                <div className="UserPoup">
                  <div className="BeforForms">
                    <div className="Form">
                      <div className="ModalHeader">
                        <div>
                          <span>Basic Information</span>
                        </div>
                      </div>

                      <div className="Modal-Body ModalForms">
                        <div className="row">
                          <div
                            className="col-12 AadhaarSendotpVerified RoleButton"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            {/* <button
                              className="btn aadharBtn"
                              variant="contained"
                              component="label"
                              // style={{ background: "#234492" }}
                              style={style.btn}
                              disabled={
                                state.NumberCounts.Editable == 1
                                  ? EmailID == "admin@gmail.com" ||
                                    EmailID == "admin@qpms.in" ||
                                    state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.EmployeeProfile
                                        .EmployeeProfileList &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .is_pending == false
                                  : state.EmployeeProfile.EmployeeProfileList
                                        .is_pending == false
                                    ? true
                                    : false
                              }
                              onClick={(e) => {
                                dispatch(
                                  setTheSumbitOtpFormsAadhar_verified(true),
                                );

                                setActiveBtn(true);
                                setregularBtn(false);
                                if (state.NumberCounts.Editable == 2) {
                                  setData({
                                    ...datas,
                                    first_name: "",
                                    dob: "",
                                    gender: "",

                                    aadhar_number:
                                      state.idverfiyicationapidatas
                                        .FirstAadharNumber != ""
                                        ? state.idverfiyicationapidatas
                                            .FirstAadharNumber
                                        : "",
                                    phoneNum: "",
                                  });
                                  setAge("");
                                }
                              }}
                            >
                              UIDAI Verification
                            </button> */}
                            {/* <button
                              className="btn aadharBtn "
                              variant="contained"
                              component="label"
                              // style={{ background: "#234492" }}
                     disabled={
  state.NumberCounts.Editable == 1
    ? (
        EmailID == "admin@gmail.com" ||
        EmailID == "admin@qpms.in" ||
        state.ClientBranchIDs.SUBROLE == 3
          ? false
          : (
              state.EmployeeProfile.EmployeeProfileList &&
              state.EmployeeProfile.EmployeeProfileList.is_pending == false
            )
      )
    : state.EmployeeProfile.EmployeeProfileList.is_pending == false ?  true  : false
}
                              style={style.regularbtn}
                              onClick={(e) => {
                                setActiveBtn(false);
                                setregularBtn(true);
                                dispatch(setTheSumbitOtpFormsAadhar_verified(false))
                                if (
                                  // url &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != undefined &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != null &&
                                  // state.idverfiyicationapidatas
                                  //   .AAdharFrontImagesDatas != ""
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != undefined &&
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != null &&
                                  state.idverfiyicationapidatas
                                    .AAdharFrontImagesDatas != ""
                                ) {
                                  const [day, month, year] =
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas != undefined &&
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas.dob !=
                                      undefined &&
                                    state.idverfiyicationapidatas
                                      .AAdharFrontImagesDatas.dob != null &&
                                    state.idverfiyicationapidatas.AAdharFrontImagesDatas.dob.split(
                                      "/"
                                    );
                                  const formattedDOB = `${year}-${month}-${day}`;
                                  const AadharNumber =
                                    state.idverfiyicationapidatas.AAdharFrontImagesDatas.aadhar_id.replace(
                                      /\s/g,
                                      ""
                                    );
                                  setData({
                                    ...datas,
                                    first_name:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.name.toUpperCase(),
                                    // first_name: FirstName,
                                    // last_name: LastName,
                                    last_name:"",
                                    dob: formattedDOB,
                                    gender:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender,

                                    aadhar_number:
                                      state.idverfiyicationapidatas
                                        .FirstAadharNumber != ""
                                        ? state.idverfiyicationapidatas
                                            .FirstAadharNumber
                                        : "",
                                  });
                                  SetGender({
                                    ...ForGender,

                                    Male:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Male",
                                    Female:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Female",
                                    other:
                                      state.idverfiyicationapidatas
                                        .AAdharFrontImagesDatas.gender ==
                                      "Others",
                                  });
                                }
                              }}
                            >
                              Manual Verification
                            </button> */}
                          </div>

                          {/* ----Aadhar---Card-----Front----Images----------------- */}
                          {/* 
                          {
                          state.NumberCounts.Editable != 1 ||
                          state.ClientBranchIDs.SUBROLE == 3 ? ( */}
                          <div class="col-6 mt-4">
                            <div>
                              <small style={{ color: "red" }}>
                                {/* Note: Please upload the image . Ensure that
                                  the file is a minimum of 10 MB in size and is
                                  in JPG, JPEG or PNG format. */}
                                Note:Upload the pictures, please. Verify that
                                the file is in the JPG, JPEG, or PNG format and
                                that its size is less than 10 MB.
                              </small>
                            </div>
                            <>
                              <label
                                style={{
                                  margin: 0,
                                  padding: 10,
                                  width: "100%",
                                  display: "block",
                                }}
                                className="form-label"
                              >
                                Aadhaar Front image
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                            </>

                            <>
                              {urlsign ? (
                                <>
                                  <img
                                    src={urlsign}
                                    className="pointer"
                                    onClick={(e) => {
                                      if (state.NumberCounts.Editable == 1) {
                                        window.open(urlsign);
                                      }
                                    }}
                                    style={{
                                      // height: 115,
                                      // width: 115,
                                      // marginRight: 25,
                                      // borderRadius: "50%",
                                      height: "153px",
                                      width: "198px",
                                      margin: "13px 25px 21px 0px",

                                      border: "4px solid #234492",
                                      borderRadius: "12px",
                                      marginRight: "25",
                                    }}
                                    alt="Image"
                                  />
                                </>
                              ) : (
                                <>
                                  {/* <p
                                      style={{
                                        margin: 0,
                                        padding: 10,
                                        width: "200px",
                                      }}
                                    >
                                      Aadhaar Front image
                                      {state.NumberCounts.Editable == 1 ? (
                                        ""
                                      ) : (
                                        <span style={{ color: "red" }}>*</span>
                                      )}
                                      <small style={{ color: "red" }}>
                                        Note:Images only Supported
                                      </small>
                                    </p> */}
                                </>
                              )}

                              {!urlsign ? (
                                <>
                                  {/* <Button
                                      className=" doctorupload"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#234492",
                                        color: "white",
                                        fontSize: "11px",
                                      }}
                                    >
                                      <p>
                                        Upload Image
                                        <input
                                          type="file"
                                          hidden
                                          disabled={
                                            state.NumberCounts.Editable == 1
                                              ? true
                                              : false
                                          }
                                          accept="image/png, image/jpeg"
                                          onChange={(e) => handleFiles2(e)}
                                        />
                                      </p>
                                    </Button> */}
                                  <div className="w-100">
                                    <Button
                                      className="btn doctorupload"
                                      variant="contained"
                                      component="label"
                                      style={{
                                        background: "#234492",
                                        color: "#fff",
                                        fontSize: "11px !important",
                                        marginLeft: "12px",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        hidden
                                        disabled={
                                          state.NumberCounts.Editable == 1 &&
                                            state.ClientBranchIDs.SUBROLE != 3
                                            ? true
                                            : false
                                        }
                                        accept="image/png, image/jpeg"
                                        onChange={(e) => handleFiles2(e)}
                                        ref={fileInputAadhaar}
                                      />
                                      Upload Image
                                    </Button>
                                  </div>
                                </>
                              ) : null}

                              {
                                // state.idverfiyicationapidatas
                                //   .Idverificationanotherapidatas != [] &&

                                urlsign ? (
                                  <>
                                    <div
                                      className="w-100 d-flex "
                                      style={{
                                        gap: "12px",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <Button
                                        className=" remove doctorupload"
                                        variant="contained"
                                        onClick={(e) => {
                                          cancel2(e);
                                          setData({
                                            ...data,
                                            aadhar_number: "",
                                            first_name: "",
                                            // last_name: "",
                                            email_id: "",
                                            phoneNum: "",
                                            placeofBirth: "",
                                            dob: "",
                                            emergency_contact_number: "",
                                            blood_group: "",
                                            religion: "",
                                            personal_identification_mark: "",
                                            emergency_contact_relation: "",
                                          });
                                          setAadharsent(false);
                                          setfamily_member_val(null);
                                          setbloodgroupval({});
                                          setreligionval({});
                                        }}
                                        style={{
                                          background: "#234492",
                                          color: "white",
                                          fontSize: "11px !important",
                                          width: "fit-content",
                                        }}
                                        disabled={
                                          state.NumberCounts.Editable == 1 &&
                                            EmailID != "admin@gmail.com" &&
                                            EmailID != "admin@qpms.in"
                                            ? true
                                            : false
                                        }
                                      >
                                        Remove Image
                                      </Button>
                                      <Downloads_doc url={urlsign} />
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )
                              }
                            </>
                            <p className="Error" style={{ marginTop: "3px" }}>
                              {adharerr}
                            </p>
                          </div>
                          {/* ) : null} */}

                          {/* <ImageUploader/> */}

                          {/* 
   -----------------------Profiles--------------------------------- */}

                          <div className="col-6 mt-4">
                            <label
                              for="validationCustom01"
                              class="form-label mt-5"
                              style={{ width: "100%" }}
                            >
                              Profile
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>

                            {url ? (
                              <img
                                src={url}
                                onClick={(e) => {
                                  if (state.NumberCounts.Editable == 1) {
                                    window.open(url);
                                  }
                                }}
                                className="pointer"
                                style={{
                                  // height: 115,
                                  // width: 115,
                                  height: "153px",
                                  width: "198px",
                                  margin: "13px 25px 21px 0px",
                                  /* border-radius: 50%; */
                                  border: "4px solid #234492",
                                  borderRadius: "12px",
                                  marginRight: "25",
                                  //borderRadius: "50%",
                                }}
                                alt="Image"
                              />
                            ) : // <p style={{ margin: 0, padding: 10 }}>
                              //   Upload Profile Picture
                              // </p>
                              null}

                            {!url ? (
                              <div className="w-100">
                                <Button
                                  className="btn doctorupload"
                                  variant="contained"
                                  component="label"
                                  style={{
                                    background: "#234492",
                                    color: "#fff",
                                    fontSize: "11px !important",
                                  }}
                                >
                                  <input
                                    type="file"
                                    hidden
                                    accept="image/png, image/jpeg"
                                    ref={fileInputRef}
                                    onChange={(e) => handleFiles(e)}
                                  />
                                  Upload Image
                                </Button>
                              </div>
                            ) : (
                              <></>
                            )}

                            {url ? (
                              <>
                                <div
                                  className="w-100 d-flex "
                                  style={{
                                    gap: "12px",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Button
                                    className="btn remove doctorupload"
                                    variant="contained"
                                    onClick={(e) => {
                                      cancel(e);
                                      setImagest(false);
                                    }}
                                    disabled={
                                      state.NumberCounts.Editable == 1 &&
                                        EmailID != "admin@gmail.com" &&
                                        EmailID != "admin@qpms.in"
                                        ? true
                                        : false
                                    }
                                    style={{
                                      color: "#fff",
                                      width: "fit-content",
                                    }}
                                  // style={{
                                  //   background: "#234492", color: "#fff",
                                  //   fontSize:"11px !important"

                                  //  }}
                                  >
                                    Remove Image
                                  </Button>
                                  <Downloads_doc url={url} />
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                            <p className="Error" style={{ marginTop: "3px" }}>
                              {profileErr}
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Name
                            </label>

                            <span style={{ color: "red" }}>*</span>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="first_name"
                              value={datas.first_name}
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  // setValidations(0);

                                  setfirsterro("");
                                } else {
                                  // setValidations(1);
                                  setfirsterro(
                                    "First Name  should not exit  more than the 150 characters",
                                  );
                                }
                              }}
                            />
                            {/* <p className="Error" style={{ marginLeft: "-5px" }}>
                              {firsterro}
                            </p> */}
                          </div>

                          {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Last Name
                            </label>
                           
                            <input
                              type="text"
                              class="form-control"
                              required
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              autocomplete="off"
                              value={datas.last_name}
                              name="last_name"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                  setlasterro("");
                                  setValidations(0);
                                } else {
                                  setValidations(1);
                                  setlasterro(
                                    "Last Name  should not exit  more than the 150 characters"
                                  );
                                }
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {lasterro}
                            </p>
                          </div>
 */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Phone Number
                            </label>
                            <span style={{ color: "red" }}>*</span>

                            <input
                              type="number" // Changed from "number" to "text" to better control input
                              step="1"
                              onKeyDown={(evt) => {
                                preventZoom(evt);
                              }}
                              onPaste={(evt) => handlePaste(evt)} // Handle pasting
                              onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              className="form-control"
                              required
                              autoComplete="off"
                              value={datas.phone_number}
                              name="phone_number"
                              onChange={(e) => {
                                const value = e.target.value;

                                const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                sphoneerro("");
                                if (
                                  value.length <= 10 &&
                                  (phoneRegex.test(value) || value === "")
                                ) {
                                  HandleChanges(e);
                                }
                              }}
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {phoneerro}
                            </p>
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Father/Husband Name
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="father_husband_name"
                              value={datas.father_husband_name || ""}
                              onChange={(e) => HandleChanges(e)}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Emergency Contact Person
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="emergency_contact_person"
                              value={datas.emergency_contact_person || ""}
                              onChange={(e) => HandleChanges(e)}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Emergency Contact
                            </label>

                            <input
                              //  type="text" // Changed from "number" to "text" to better control input
                              step="1"
                              type="number"
                              onKeyDown={(evt) => {
                                preventZoom(evt);
                              }}
                              onPaste={(evt) => handlePaste(evt)} // Handle pasting
                              onWheel={(evt) => preventZoom(evt)} // Prevent zooming with the mouse wheel
                              ref={inputRef}
                              className="form-control"
                              required
                              value={datas.emergency_contact_number}
                              autoComplete="off"
                              name="emergency_contact_number"
                              onChange={(e) => {
                                const value = e.target.value;

                                const phoneRegex = /^[1-9][0-9]{0,9}$/;
                                setemergencyErr("");
                                //  if(isNaN(e.target.value) ==  false){
                                if (
                                  value.length <= 10 &&
                                  (phoneRegex.test(value) || value === "")
                                ) {
                                  HandleChanges(e);
                                }
                                // }
                              }}
                            />
                          </div>

                          {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Email
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              required
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                              }
                              autocomplete="off"
                              value={
                                datas.email_id != "" &&
                                datas.email_id != null &&
                                datas.email_id != undefined
                                  ? datas.email_id.toLowerCase()
                                  : ""
                              }
                              name="email_id"
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                HandleChanges(e);
                                setEmail(e.target.value);
                                setEmailerro("");
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {emailerro}
                            </p>
                          </div> */}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Aadhaar Number
                            </label>
                            <span style={{ color: "red" }}>*</span>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="aadhar_number"
                              value={
                                datas?.aadhar_number
                                  ? localStorage.getItem("aadharAccess") === "true"
                                    ? `**** ****  ${datas.aadhar_number.slice(-4)}`
                                    : datas.aadhar_number
                                  : ""
                              }
                              onChange={(e) => HandleChanges(e)}
                              onKeyDown={preventZoom}
                              onPaste={handlePaste}
                              onWheel={preventZoom}
                            />
                          </div>

                          <div className="col-sm-3 mt-3 BloodroupDropdown">
                            <label for="validationCustom01" class="form-label">
                              Marital Status
                            </label>
                            <Select
                              menuPlacement="top"
                              options={maritalStatusOptions}
                              value={maritalStatusValue}
                              onChange={(e) => {
                                if (e) {
                                  setMaritalStatusValue(e);
                                  setData({
                                    ...datas,
                                    marital_status: e.value,
                                  });
                                } else {
                                  setMaritalStatusValue({
                                    value: "",
                                    label: "Select",
                                  });
                                  setData({ ...datas, marital_status: "" });
                                }
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3 BloodroupDropdown">
                            <label for="validationCustom01" class="form-label">
                              Gender
                            </label>
                            <Select
                              menuPlacement="top"
                              options={genderOptions}
                              value={genderDropdownValue}
                              onChange={(e) => {
                                if (e) {
                                  setGenderDropdownValue(e);
                                  setData({ ...datas, gender: e.value });
                                } else {
                                  setGenderDropdownValue({
                                    value: "",
                                    label: "Select",
                                  });
                                  setData({ ...datas, gender: "" });
                                }
                              }}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Birth
                            </label>
                            {/* <span style={{ color: "red" }}>*</span> */}

                            <input
                              type={
                                state.NumberCounts.Editable == 1 &&
                                  state.ClientBranchIDs.SUBROLE != 3
                                  ? "text"
                                  : "date"
                              }
                              class="form-control"
                              required
                              autocomplete="off"
                              value={datas.dob || ""}
                              name="dob"
                              //  min={getMinimumDate()}
                              max={today} // Set the max attribute to today's date
                              onKeyDown={preventTyping}
                              onFocus={(e) => {
                                // e.target.showPicker()
                                if (
                                  !document.body.classList.contains(
                                    "swal2-shown",
                                  )
                                ) {
                                  e.target.showPicker();
                                } else {
                                  e.preventDefault();
                                }
                              }} // Programmatically trigger the date picker on focus
                              // min="1955-01-01"
                              // max="2004-12-01"
                              onChange={(e) => {
                                setdateerro("");
                                HandleChanges(e);
                                // setAge("");

                                setBirthDate(e.target.value);
                                calculateAge();
                              }}
                            />
                            {/* {state.NumberCounts.Editable == 1 ? null : ( */}
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {dateerro}
                            </p>
                            {/* )} */}
                          </div>
                          {/* {datas.dob != "" &&
                          !datas.dob.includes("undefined") &&
                          datas.dob != undefined &&
                          datas.dob != null ? (
                            <div className="col-sm-3 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Age
                              </label>
                              <input
                                type="number"
                                class="form-control"
                                disabled={
                                  state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "admin@qpms.in"
                                    ? true
                                    : false
                                }
                                required
                                autocomplete="off"
                                value={age}
                                name="age"
                                readOnly={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                // onClick={calculateAge}
                              />
                            </div>
                          ) : null} */}
                          {/* 
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Place Of Birth
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="placeofBirth"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in" &&
                                state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              value={datas.placeofBirth}
                              onChange={(e) => {
                                HandleChanges(e);
                              }}
                            />
                          </div> */}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Qualification
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="qualification"
                              value={datas.qualification || ""}
                              onChange={(e) => HandleChanges(e)}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Date of Joining
                            </label>
                            <input
                              type="date"
                              class="form-control"
                              autocomplete="off"
                              name="date_of_joining"
                              value={datas.date_of_joining || ""}
                              onChange={(e) => HandleChanges(e)}
                              max={today}
                            />
                          </div>

                          {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Employee Code
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="user_uid"
                              readOnly={
                                // state.NumberCounts.Editable == 1 &&
                                //   state.ClientBranchIDs.SUBROLE != 3
                                //   ? true
                                //   : false
                                state.NumberCounts.Editable == 1
                                  ? state.ClientBranchIDs.SUBROLE == 3
                                    ? false
                                    : state.ClientBranchIDs.SUBROLE == 1 &&
                                        state.NumberCounts.EmployeeFormFIll ==
                                          false
                                      ? true
                                      : false
                                  : state.NumberCounts.EmployeeFormFIll == true
                                    ? false
                                    : true
                              }
                              maxLength={50}
                              placeholder="e.g. EMP001"
                              value={datas.user_uid || ""}
                              onChange={(e) => {
                                const value = e.target.value
                                  .toUpperCase() // enforce uppercase
                                  .replace(/[^A-Z0-9_-]/g, ""); // remove invalid chars
                                setemployee_code_err("");
                                HandleChanges({
                                  target: {
                                    name: "user_uid",
                                    value,
                                  },
                                });

                                // HandleChanges(e);
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {employee_code_err}
                            </p>
                          </div> */}

                          <div className="col-sm-3 mt-3 BloodroupDropdown">
                            <label for="validationCustom01" class="form-label">
                              Blood group
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>

                            <Select
                              //  styles={customStyles}
                              name="BranchSearch"
                              labelledBy="Select"
                              options={Blood_Group}
                              menuPlacement="top"
                              onChange={(e) => {
                                if (e != null) {
                                  setbloodgroupval(e);
                                  setData({
                                    ...datas,
                                    blood_group: e.label,
                                  });
                                } else {
                                  setData({
                                    ...datas,
                                    blood_group: "",
                                  });
                                  setbloodgroupval({
                                    value: "",
                                    label: "select",
                                  });
                                }
                                setblodderr("");
                              }}
                              value={BloddGroupvalue}
                            />
                          </div>

                          {/* <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Personal Identification Mark
                            </label>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="personal_identification_mark"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                EmailID != "admin@gmail.com" &&
                                EmailID != "admin@qpms.in" &&
                                state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              value={datas.personal_identification_mark}
                              onChange={(e) => {
                                if (e.target.value.length < 150) {
                                  HandleChanges(e);
                                }
                              }}
                            />
                          </div> */}
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Scrum ID
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="scrum_id"
                              value={datas.scrum_id || ""}
                              onChange={(e) => HandleChanges(e)}
                            />
                          </div>
                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Employee Code
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              autocomplete="off"
                              name="user_uid"
                              value={datas.user_uid || ""}
                              onChange={(e) => HandleChanges(e)}
                            />
                          </div>

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Height
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>

                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="height"
                              value={datas.height}
                              min="50"
                              max="250"
                              onChange={(e) => {
                                const value = e.target.value;
                                setheighterr("");
                                // Allow empty value (for clearing input)
                                if (value === "") {
                                  HandleChanges(e);
                                  return;
                                }

                                // Convert to number
                                const num = Number(value);

                                // Allow typing if the value is below 50 but could become valid (e.g., "5" → "50")
                                if (num >= 50 && num <= 250) {
                                  HandleChanges(e);
                                } else if (num < 50 && value.length < 3) {
                                  // Allow partial typing like "5", "25" etc. (before it becomes valid)
                                  HandleChanges(e);
                                } else {
                                  // Prevent typing numbers that go beyond allowed range
                                  e.preventDefault();
                                }
                              }}
                              onWheel={(e) => e.preventDefault()} // prevent scroll change
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key))
                                  e.preventDefault(); // prevent invalid chars
                              }}
                              placeholder="Enter height in cm"
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {heightErr}
                            </p>
                          </div>
                          {console.log(datas, "datasdatas")}

                          <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                              Weight
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </label>

                            <input
                              type="number"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="weight"
                              disabled={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "admin@qpms.in"
                                  ? true
                                  : false
                              }
                              readOnly={
                                state.NumberCounts.Editable == 1 &&
                                  EmailID != "admin@gmail.com" &&
                                  EmailID != "admin@qpms.in" &&
                                  state.EmployeeProfile.EmployeeProfileList != ""
                                  ? true
                                  : false
                              }
                              value={datas.weight}
                              onKeyDown={(e) => {
                                if (
                                  e.key === "-" ||
                                  e.key === "e" ||
                                  e.key === "+"
                                ) {
                                  e.preventDefault(); // Block negative, scientific notation, + sign
                                }
                              }}
                              min="20"
                              max="200"
                              onChange={(e) => {
                                const value = e.target.value;
                                console.log(value, "sudpoasd value");
                                setweighterr("");
                                if (value.includes("-")) {
                                  e.preventDefault();
                                  return;
                                }

                                // Allow empty value (for clearing input)
                                if (value === "") {
                                  HandleChanges(e);
                                  return;
                                }

                                // Convert to number
                                const num = Number(value);

                                // Allow typing if the value is below 50 but could become valid (e.g., "5" → "50")
                                if (num >= 50 && num <= 250) {
                                  HandleChanges(e);
                                } else if (num < 50 && value.length < 3) {
                                  // Allow partial typing like "5", "25" etc. (before it becomes valid)
                                  HandleChanges(e);
                                } else {
                                  // Prevent typing numbers that go beyond allowed range
                                  e.preventDefault();
                                }
                              }}
                              // onWheel={(e) => e.preventDefault()}
                              // onKeyDown={(e) => {
                              //   if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                              // }}
                              placeholder="Enter weight in kg"
                            />

                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {weighterr}
                            </p>
                          </div>

                          {/* {ActiveBtn == false && (


      <div className="col-sm-3 mt-3">
                            <label for="validationCustom01" class="form-label">
                             Remarks for Manual Verification
                            </label>

                                                          <span style={{ color: "red" }}>*</span>

                            <input
                              type="text"
                              class="form-control"
                              id="validationCustom01"
                              autocomplete="off"
                              name="manual_aadhaar_reason"
                              readOnly={
                                                     state.ClientBranchIDs.SUBROLE == 2 || state.NumberCounts.EmployeeFormFIll == true ?  false :       
    state.NumberCounts.Editable == 1  && state.NumberCounts.EmployeeFormFIll == true ? false :state.ClientBranchIDs.SUBROLE == 3 ?
    false : true



                             }                 
                             disabled={         
                              state.ClientBranchIDs.SUBROLE == 2 || state.NumberCounts.EmployeeFormFIll == true ?  false :       
    state.NumberCounts.Editable == 1  && state.NumberCounts.EmployeeFormFIll == true ? false :state.ClientBranchIDs.SUBROLE == 3 ?
    false : true
                              }
                              value={datas.manual_aadhaar_reason}
                              onChange={(e) => {
                                                               HandleChanges(e);

                                setmanual_reason_err("")
                              }}
                            />
                            <p className="Error" style={{ marginLeft: "-5px" }}>
                              {manual_reasonerr}
                            </p>
                          </div>
)} */}
                        </div>
                      </div>

                      {state.CasualApproveRequestDatas.Inquriy?.is_pending && (
                        <div
                          className="RoleButton"
                          style={{
                            display: "flex",
                            gap: "15px",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "0px 15px",
                            marginBottom: "20px",
                          }}
                        >
                          <button
                            class="btn ButtonCSS"
                            style={{
                              color: "#ffff",
                              background: "#234492",
                            }}
                            onClick={(e) => {
                              HandleSaveNext();
                            }}
                          >
                            Save & Continue
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={CroppImageViewCount == 1 ? profileFiles : aadhaarFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}
    </>
  );
};

export default CasualBasicInfoTab;
